import { useEffect, type ReactNode } from 'react';
import { useStore } from '@nanostores/react';
import { $currentUser } from '~/lib/stores/auth';
import { initPostHog, identify, reset } from '~/lib/posthog';

export default function PostHogProvider({ children }: { children: ReactNode }) {
  const user = useStore($currentUser);

  // Initialize PostHog once on mount (async — fetches config from server)
  useEffect(() => {
    initPostHog();
  }, []);

  // Reactively identify/reset when auth state changes
  useEffect(() => {
    if (user) {
      identify(user.id, {
        email: user.email,
        name: user.displayName,
        tier: user.tier,
        role: user.role,
      });
    } else {
      reset();
    }
  }, [user]);

  return <>{children}</>;
}
